















































































































































































































import Vue from 'vue';
/* tslint:disable */
import moment from 'moment';
import { toString } from 'lodash';
import { api, MEMBER_API_SUB_URLS, V2 } from '@/api';
import {
  EventBus
} from '@/event-bus';
import {
  required,
  requiredIf,
  maxLength
} from 'vuelidate/lib/validators';
import {
  date,
  dateHelpers
} from '@/validations';
import {
  dateFormat,
  dialogMaxWidth,
  datePickerFormat
} from '@/constants';

import {
  DateFormat,
  DOBAllowedDates,
  CloseFullscreenWrapper,
  FormValidation,
  TriggerRefreshError
} from '@/mixins/index';
import {
  DatePicker
} from '@/components/form-components';
import InputMaskTypes from '@/directives/input-mask/input-mask-types';
import {
  FullscreenWrapper,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading
} from '@/components/fullscreen-wrapper-components';
import { ExtendMixins } from '@/services';
import {
  AddDebitCardFormModel, DebitCards,
  MemberDependentResponseModel,
  MemberPaymentMethodsResponseModel,
  SelectOption,
  UserModel
} from '@/@types/member';

interface Data {
  isLoading: boolean;
  showSuccessMessage: boolean;
  successMessage: string;
  showErrorMessage: boolean;
  showSubmitError: boolean;
  submitErrorMessage: string;
  showValidateDependentError: boolean;
  validateDependentErrorMessage: string;
  showAddDependentError: boolean;
  addDependentErrorMessage: string;
  confirmBeforeClose: boolean;
  formModel: AddDebitCardFormModel;
  blankDependent: {
    dependentId: string;
    firstName: string;
    lastName: string;
    relationship: string;
    dateOfBirth: string;
    accountsCovered: string;
  };
  relationshipOptions: SelectOption[];
  dependentTypeArray: string[];
  isNewDependent: boolean;
  showExactMatchError: boolean;
  showPartialMatchDialog: boolean;
  dialogMaxWidth: string;
  showSubmitErrorMessage: boolean;
}

export default ExtendMixins(
  DateFormat,
  DOBAllowedDates,
  CloseFullscreenWrapper,
  FormValidation,
  TriggerRefreshError,
)
  .extend({
    name: 'AddDebitCard',
    props: {
      params: {
        type: Object as () => any,
        required: true
      }
    },
    data(): Data {
      return {
        isLoading: false,
        showSuccessMessage: false,
        successMessage: this.params.successMessage,
        showErrorMessage: false,
        showSubmitError: false,
        submitErrorMessage: this.params.submitErrorMessage,
        showValidateDependentError: false,
        validateDependentErrorMessage: this.params.validateDependentErrorMessage,
        showAddDependentError: false,
        addDependentErrorMessage: this.params.addDependentErrorMessage,
        confirmBeforeClose: true,
        formModel: {
          requestCardFor: '',
          dependentId: '',
          firstName: '',
          lastName: '',
          relationship: '',
          dateOfBirth: '',
          accountsCovered: '',
          termsAndConditions: false,
        },
        blankDependent: {
          dependentId: '',
          firstName: '',
          lastName: '',
          relationship: '',
          dateOfBirth: '',
          accountsCovered: ''
        },
        relationshipOptions: [
          {text: this.$options.filters.t(['add-debit-card_label_spouse', 'global_spouse']), value: 'Spouse'},
          {text: this.$options.filters.t(['add-debit-card_label_child', 'global_child']), value: 'Child'}
        ],
        dependentTypeArray: ['Self', 'Spouse', 'Child'],
        isNewDependent: false,
        showExactMatchError: false,
        showPartialMatchDialog: false,
        showSubmitErrorMessage: false,
        dialogMaxWidth
      };
    },
    beforeMount() {
      this.constructShowErrorModel('formModel');
    },
    mounted() {
      this.setRequestForOption();
    },
    validations: {
      formModel: {
        requestCardFor: {
          required
        },
        dependentId: {
          required: requiredIf(function (this: any): boolean {
            return this.formModel.requestCardFor === 'dependent';
          })
        },
        firstName: {
          required: requiredIf(function (this: any): boolean {
            return this.formModel.requestCardFor === 'dependent';
          }),
          maxLength: maxLength(15)
        },
        lastName: {
          required: requiredIf(function (this: any): boolean {
            return this.formModel.requestCardFor === 'dependent';
          }),
          maxLength: maxLength(24)
        },
        relationship: {
          required: requiredIf(function (this: any): boolean {
            return this.formModel.requestCardFor === 'dependent';
          }),
        },
        dateOfBirth: {
          required: requiredIf(function (this: any): boolean {
            return this.formModel.requestCardFor === 'dependent';
          }),
          date,
          dateOfBirth(value): boolean {
            return dateHelpers.sameOrBeforeDate(moment()
              .format(dateFormat))(value);
          }
        },
        accountsCovered: {
          required: requiredIf(function (this: any): boolean {
            return this.showAccountsCovered;
          })
        },
        termsAndConditions: {
          required
        }
      }
    },
    computed: {
      // Getters
      user(): UserModel {
        return this.$store.getters.user;
      },
      paymentMethods(): MemberPaymentMethodsResponseModel {
        return this.$store.getters.paymentMethods;
      },
      dependents(): MemberDependentResponseModel[] {
        return this.$store.getters.dependents;
      },

      // Data
      debitCards(): DebitCards[] {
        let cardArray = [];
        this.dependents.forEach(dep => {
          dep.debitcards.forEach(card => {
            cardArray.push({
              dependentId: dep.dependentId,
              dependentType: dep.dependentType,
              firstName: dep.firstName,
              middleName: dep.middleName,
              lastName: dep.lastName,
              dateOfBirth: dep.dateOfBirth,
              ...card
            });
          });
        });
        return cardArray;
      },
      selfDependent(): MemberDependentResponseModel {
        return this.dependents.find(dependent => {
          return dependent.dependentType === 'Self';
        });
      },
      selfCards(): DebitCards[] {
        return this.debitCards.filter(card => {
          return card.dependentType === 'Self';
        });
      },
      activeSelfCards(): DebitCards[] {
        return this.debitCards.filter(card => {
          return card.dependentType === 'Self' && card.cardElection;
        });
      },
      activeSelfCardPackageKeys(): string[] {
        return this.activeSelfCards.reduce((keysArray, card) => {
          keysArray.push(card.cardPackageKey.toString());
          return keysArray;
        }, []);
      },
      availableSelfCards(): DebitCards[] {
        return this.debitCards.filter(card => {
          return card.dependentType === 'Self' && !card.cardElection;
        });
      },
      hasAvailableSelfCards(): boolean {
        return !!this.availableSelfCards.length;
      },
      availableSelfCardPackageKeys(): string[] {
        return this.availableSelfCards.reduce((keysArray, card) => {
          keysArray.push(card.cardPackageKey);
          return keysArray;
        }, []);
      },
      selectedDependentCards(): DebitCards[] {
        return this.debitCards.filter(card => {
          return card.dependentId === this.selectedDependentId;
        });
      },
      dependentCards(): DebitCards[] {
        return this.debitCards.filter(card => {
          return card.dependentType !== 'Self';
        });
      },
      availableDependentCards(): DebitCards[] {
        return this.dependentCards.filter(card => {
          return !card.cardElection && this.activeSelfCardPackageKeys.indexOf(card.cardPackageKey.toString()) > -1;
        });
      },

      // Form options
      showMyselfOption(): boolean {
        return this.hasAvailableSelfCards;
      },
      showDependentOption(): boolean {
        let activeSelfCardsWithoutSuppress = this.activeSelfCards.filter(card => {
          return !card.suppressDependentCards;
        });
        return !!activeSelfCardsWithoutSuppress.length;
      },
      requestCardOptions(): SelectOption[] {
        let options = [];
        if (this.showMyselfOption) {
          options.push({
            text: this.$options.filters.t('add-debit-card_form-option_myself'),
            value: 'myself'
          });
        }
        if (this.showDependentOption) {
          options.push({
            text: this.$options.filters.t('add-debit-card_form-option_dependent'),
            value: 'dependent'
          });
        }
        return options;
      },
      showAccountsCovered(): boolean {
        if (this.formModel.requestCardFor === 'myself') {
          return this.selfCards.length > 1;
        }
        return this.selfCards.length > 1 && this.formModel.dependentId !== '';
      },
      accountsCoveredOptions(): SelectOption[] {
        let cardPurseTypes = [],
          cards = [];
        if (this.formModel.requestCardFor === 'myself') {
          cards = this.availableSelfCards;
        } else if (this.formModel.requestCardFor === 'dependent') {
          if (this.formModel.dependentId !== '*') {
            cards = this.selectedDependentCards.filter(card => {
              let suppressDependentCards = card.suppressDependentCards,
                selfCardElectionFalse = this.availableSelfCardPackageKeys.indexOf(card.cardPackageKey.toString()) > -1;
              return !card.cardElection && !suppressDependentCards && !(selfCardElectionFalse);
            });
          } else {
            cards = this.selfCards.filter(card => {
              let suppressDependentCards = card.suppressDependentCards,
                selfCardElectionFalse = this.availableSelfCardPackageKeys.indexOf(card.cardPackageKey.toString()) > -1;
              return !suppressDependentCards && !selfCardElectionFalse;
            });
          }
        }
        cards.forEach(card => {
          card.cardPurseType.forEach(type => {
            if (cardPurseTypes.indexOf(type) === -1) {
              cardPurseTypes.push(type);
            }
          });
        });
        // @ts-ignore
        return cardPurseTypes.sort((a, b) => {
          return a > b;
        });
      },
      dependentNameOptions(): SelectOption[] {
        let dependents = this.availableDependentCards.reduce((cardArray, card) => {
          let cardArrayIndex = cardArray.findIndex(c => {
            return c.dependentId === card.dependentId;
          });
          if (cardArrayIndex === -1) {
            cardArray.push(card);
          }
          return cardArray;
        }, []);
        // Create an array for the v-select component to digest
        let optionsArray = dependents.map(dependent => {
          return {
            text: `${dependent.firstName} ${dependent.lastName}`,
            type: dependent.dependentType,
            value: dependent.dependentId
          };
        });
        // Separate and sort the dependents
        let spouseOptions = optionsArray.filter(option => {
          return option.type === 'Spouse';
        })
          .sort((a, b) => {
            if (a.text.toLowerCase() < b.text.toLowerCase()) {
              return -1;
            }
            if (a.text.toLowerCase() > b.text.toLowerCase()) {
              return 1;
            }
          });
        let childOptions = optionsArray.filter(option => {
          return option.type === 'Child';
        })
          .sort((a, b) => {
            if (a.text.toLowerCase() < b.text.toLowerCase()) {
              return -1;
            }
            if (a.text.toLowerCase() > b.text.toLowerCase()) {
              return 1;
            }
          });
        let sortedOptions: SelectOption[] = spouseOptions.concat(childOptions);
        // Add the new cardholder option
        sortedOptions.push({
          text: this.$options.filters.t('add-debit-card_label_new-cardholder'),
          value: '*'
        });
        return sortedOptions;
      },
      selectedDependentId(): number | string {
        if (this.formModel.requestCardFor === 'myself') {
          return this.selfDependent.dependentId;
        } else {
          return this.formModel.dependentId;
        }
      },
      selectedCardPackageKey(): string | number {
        // If there is only one self card
        if (this.selfCards.length === 1) {
          return this.selfCards[0].cardPackageKey;
        }

        // If Accounts Covered dropdown has a selection
        if (this.formModel.accountsCovered !== '') {
          let matchingCard = this.selfCards.find(card => {
            // @ts-ignore
            let purseTypeIndex = card.cardPurseType.findIndex(type => {
              return type === this.formModel.accountsCovered;
            });
            return purseTypeIndex > -1;
          });
          return matchingCard.cardPackageKey;
        }

        return '';
      },
      termsAndConditionsLabel(): string {
        if (this.paymentMethods.medicalCrossoverElection
          || this.paymentMethods.dentalCrossoverElection) {
          return 'add-debit-card_form-label_terms-and-conditions-crossover';
        }
        return 'add-debit-card_form-label_terms-and-conditions';
      },

//      VALIDATIONS
      requestCardForErrors(): string[] {
        const formField = 'formModel.requestCardFor';
        return this.FormValidationMixin.constructErrors(
          formField,
          [
            this.FormValidationMixin.validateField(formField, ['add-debit-card_form-error_request-card-for_required', 'global_form-error_default_required'], 'required'),
          ]
        );
      },
      dependentIdErrors(): string[] {
        const formField = 'formModel.dependentId';
        return this.FormValidationMixin.constructErrors(
          formField,
          [
            this.FormValidationMixin.validateField(formField, ['add-debit-card_form-error_dependent-name_required', 'global_form-error_default_required'], 'required')
          ]
        );
      },
      firstNameErrors(): string[] {
        const formField = 'formModel.firstName';
        return this.FormValidationMixin.constructErrors(
          formField,
          [
            this.FormValidationMixin.validateField(formField, ['add-debit-card_form-error_first-name_required', 'global_form-error_first-name_required', 'global_form-error_default_required'], 'required'),
            this.FormValidationMixin.validateField(
              formField,
              ['add-debit-card_form-error_first-name_maxlength'],
              'maxLength',
              {key: 'maxLength', val: 'max'}
            )
          ]
        );
      },
      lastNameErrors(): string[] {
        const formField = 'formModel.lastName';
        return this.FormValidationMixin.constructErrors(
          formField,
          [
            this.FormValidationMixin.validateField(formField, ['add-debit-card_form-error_last-name_required', 'global_form-error_last-name_required', 'global_form-error_default_required'], 'required'),
            this.FormValidationMixin.validateField(
              formField,
              ['add-debit-card_form-error_last-name_maxlength'],
              'maxLength',
              {key: 'maxLength', val: 'max'}
            )
          ]
        );
      },
      relationshipErrors(): string[] {
        const formField = 'formModel.relationship';
        return this.FormValidationMixin.constructErrors(
          formField,
          [
            this.FormValidationMixin.validateField(formField, ['add-debit-card_form-error_relationship_required', 'global_form-error_default_required'], 'required')
          ]
        );
      },
      dateOfBirthErrors(): string[] {
        const formField = 'formModel.dateOfBirth';
        return this.FormValidationMixin.constructErrors(
          formField,
          [
            this.FormValidationMixin.validateField(formField, ['add-debit-card_form-error_dob_required', 'global_form-error_dob_required', 'global_form-error_default_required'], 'required'),
            this.FormValidationMixin.validateField(formField, ['add-debit-card_form-error_dob_invalid-format', 'global_form-error_date_invalid-format'], 'date'),
            this.FormValidationMixin.validateField(formField, 'add-debit-card_form-error_dob_invalid-dob', 'dateOfBirth')
          ]
        );
      },
      accountsCoveredErrors(): string[] {
        const formField = 'formModel.accountsCovered';
        return this.FormValidationMixin.constructErrors(
          formField,
          [
            this.FormValidationMixin.validateField(formField, ['add-debit-card_form-error_accounts-covered_required', 'global_form-error_default_required'], 'required'),
          ]
        );
      },
      termsAndConditionsErrors(): string[] {
        const formField = 'formModel.termsAndConditions';
        return this.FormValidationMixin.constructErrors(
          formField,
          [
            this.FormValidationMixin.validateField(formField, ['add-debit-card_form-error_terms-and-conditions_required', 'global_form-error_terms-and-conditions_required', 'global_form-error_default_required'], 'required')
          ]
        );
      }
    },
    methods: {
      setRequestForOption(): void {
        if (this.requestCardOptions.length === 1) {
          this.formModel.requestCardFor = this.requestCardOptions[0].value;
        }
        this.setInitFocus();
      },
      setInitFocus(): void {
        if (this.formModel.requestCardFor === 'dependent') {
          setTimeout(() => {
            (this.$refs.dependentId as any).focusInput();
          }, 350);
        } else if (this.formModel.requestCardFor === 'myself') {
          setTimeout(() => {
            (this.$refs.termsAndConditions as any).$el.focus();
          }, 350);
        } else {
          setTimeout(() => {
            (this.$refs.requestCardFor as any).focusInput();
          }, 350);
        }
      },
      deconstructDOB(): void {
        this.formModel.dateOfBirth = InputMaskTypes.date.deconstruct(this.formModel.dateOfBirth);
      },
      updateDateOfBirth(dateOfBirth): void {
        this.formModel.dateOfBirth = this.formatDate(dateOfBirth);
        this.triggerBlur('formModel.dateOfBirth');
        this.updateHasChanged();
      },
      updateRequestCardFor(event): void {
        this.isNewDependent = false;
        this.changeMade = true;
        this.triggerSelectBlur(event, 'formModel.requestCardFor');
        // Set the formModel
        Object.assign(this.formModel, this.blankDependent);
        // Reset the form
        this.resetDependentFields();
        // Mark the dependentId value dirty
        this.triggerSelectBlur(event, 'formModel.requestCardFor');
      },
      updateDependentName(event): void {
        this.changeMade = true;
        this.triggerSelectBlur(event, 'formModel.dependentId');
        let selectedDependent: any = event !== '*' ? this.dependents.find(dependent => {
          return dependent.dependentId === event;
        }) : Object.assign(this.blankDependent, {dependentId: '*'});
        // If choosing to add a new dependent, map the selected dependent values
        if (selectedDependent.dependentId !== '*') {
          this.isNewDependent = false;
          selectedDependent = {
            dependentId: selectedDependent.dependentId,
            firstName: selectedDependent.firstName,
            lastName: selectedDependent.lastName,
            relationship: selectedDependent.dependentType,
            dateOfBirth: selectedDependent.dateOfBirth,
            accountsCovered: ''
          };
        } else {
          this.isNewDependent = true;
        }
        // Set the formModel
        Object.assign(this.formModel, selectedDependent);
        // Reset the form
        this.resetDependentFields();
        // Mark the dependentId value dirty
        this.triggerSelectBlur(event, 'formModel.dependentId');
      },
      resetDependentFields(): void {
        this.triggerFocus('formModel.dependentId');
        this.triggerFocus('formModel.firstName');
        this.triggerFocus('formModel.lastName');
        this.triggerFocus('formModel.relationship');
        this.triggerFocus('formModel.dateOfBirth');
        this.triggerFocus('formModel.accountsCovered');
      },
      tryAgain(): void {
        this.showErrorMessage = false;
        this.confirmBeforeClose = true;
      },
      submitForm(): void {
        this.isLoading = true;
        this.showExactMatchError = false;
        this.showPartialMatchDialog = false;
        if (this.isNewDependent) {
          this.validateDependent();
        } else {
          this.addDebitCard();
        }
      },
      validateDependent(): void {
        this.isLoading = true;
        let payload = {
          firstName: this.formModel.firstName.trim(),
          lastName: this.formModel.lastName.trim(),
          dateOfBirth: moment(this.formModel.dateOfBirth, dateFormat).format(datePickerFormat),
        };
        // UC-REST-020 - Validate Dependent
        api.get(`${MEMBER_API_SUB_URLS.members}/${this.user.memberId}/dependents/matches${V2}`, {
          params: payload
        })
          .then((data) => {

            if (this.$store.getters.user.role === 'CSR') {

              const router = this.$router;

              EventBus.$emit('openModal', 'Error', {
                message: 'global_csr-error',
                action: {
                  label: 'global_ok',
                  performAction: function () {
                    router.push({name: 'accounts'});
                  },
                },
                hideCancel: true
              });

              return false;
            }

            let matchStatus = data.data.match;
            if (matchStatus === 'EXACT_MATCH') {
              this.showExactMatchError = true;
              this.isLoading = false;

            } else if (matchStatus === 'PARTIAL_MATCH') {
              this.showPartialMatchDialog = true;
              this.$nextTick(() => {
                (this.$refs.confirmPartialMatchButton as any).$el.focus();
              });

            } else if (matchStatus === 'NO_MATCH') {
              this.addDependent();
            }
          })
          .catch(() => {
            this.confirmBeforeClose = false;
            this.isLoading = false;
            this.hideErrors();
            this.showErrorMessage = true;
            this.showValidateDependentError = true;
          });
      },
      closePossibleMatchModal(): void {
        this.confirmBeforeClose = false;
        this.$nextTick(() => {
          this.closeFullscreenWrapper();
        });
      },
      addDependent(): void {
        this.isLoading = true;
        this.showPartialMatchDialog = false;
        let payload = {
          firstName: this.formModel.firstName.trim(),
          lastName: this.formModel.lastName.trim(),
          type: this.formModel.relationship,
          dateOfBirth: moment(this.formModel.dateOfBirth, dateFormat).format(datePickerFormat),
        };
        // UC-REST-018 - Add Dependent
        api.post(`${MEMBER_API_SUB_URLS.members}/${this.user.memberId}/dependents${V2}`, payload)
          .then((data) => {
            let response = data.data;
            let dependent = {
              dependentId: response.id,
              firstName: response.firstName,
              lastName: response.lastName,
              relationship: response.type,
              dateOfBirth: response.dateOfBirth
            };
            Object.assign(this.formModel, dependent);
            this.addDebitCard();
          })
          .catch((e) => {
            this.confirmBeforeClose = false;
            this.isLoading = false;
            this.hideErrors();
            this.showErrorMessage = true;
            this.showAddDependentError = true;
          });
      },
      addDebitCard(): void {
        this.isLoading = true;
        let payload = {
          dependentId: toString(this.selectedDependentId),
          cardPackageId: toString(this.selectedCardPackageKey),
          memberId: this.user.memberId,
        };
        // UC-REST-017 - Add Debit Card
        api.post(`${MEMBER_API_SUB_URLS.dependents}/debit-cards${V2}`, payload)
          .then(() => {
            this.refreshDebitCards();

            // GTM Event - Submit Direct Deposit
            window.dataLayer.push({
              'event': 'requestCard'
            });
          })
          .catch(() => {
            this.confirmBeforeClose = false;
            this.isLoading = false;
            this.hideErrors();
            this.showSubmitError = true;
          });
      },
      refreshDebitCards(): void {
        this.isLoading = true;
        this.$store.dispatch('getDependents')
          .then(() => {
            this.refreshPaymentMethods();
          })
          .catch(() => {
            this.isLoading = false;
            this.triggerRefreshError({
              message: ['add-debit-card_text_refresh-data-error-message', 'global_connection-error']
            });
          });
      },
      refreshPaymentMethods(): void {
        this.isLoading = true;
        this.$store.dispatch('getPaymentMethods')
          .then(() => {
            this.confirmBeforeClose = false;
            this.hideErrors();
            this.showSuccessMessage = true;
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
            this.triggerRefreshError({
              message: ['add-debit-card_text_refresh-data-error-message', 'global_connection-error']
            });
          });
      },
      hideErrors(): void {
        this.showSubmitErrorMessage = false;
        this.showValidateDependentError = false;
        this.showAddDependentError = false;
      }
    },
    components: {
      DatePicker,
      FullscreenWrapper,
      FullscreenSuccess,
      FullscreenError,
      FullscreenLoading
    }
  });
